module.exports = __webpack_public_path__ + "img/Middle-Semi-Elliptical-Attachment-R-22.ef657cf7.png";